import script from "./VABreadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./VABreadcrumb.vue?vue&type=script&setup=true&lang=ts"

import "./VABreadcrumb.vue?vue&type=style&index=0&id=66365137&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66365137"]])

export default __exports__